const database = () => new Promise((resolve, reject) => {
  const request = indexedDB.open("jm-absence-files", 1);
  request.onupgradeneeded = () => request.result.createObjectStore("absences", { keyPath: "id" });
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error);
});
export async function absenceStore(action, value) {
  const db = await database();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction("absences", action === "list" ? "readonly" : "readwrite");
    const store = transaction.objectStore("absences");
    const request = action === "list" ? store.getAll() : store.put(value);
    transaction.oncomplete = () => { db.close(); resolve(action === "list" ? request.result.filter(row => row.scope === value) : value); };
    transaction.onerror = () => { db.close(); reject(transaction.error); };
    transaction.onabort = () => { db.close(); reject(transaction.error); };
  });
}
